module.exports = __webpack_public_path__ + "img/cars.c93984e0.svg";